<template>
  <QCard
    class="rounded-borders-lg row q-pa-md shadow-4 bdr-a-grey-3"
    :style="{ width: width }"
  >
    <div v-if="loading" class="row justify-center q-py-xl full-width">
      <SAISpinner />
    </div>
    <div v-else class="full-width">
      <div class="row justify-center q-mb-lg full-width">
        <SAICardToggle active>
          <p class="text-weight-medium text-body q-py-sm q-px-md">
            Lease To Date
          </p>
        </SAICardToggle>
      </div>
      <div class="row q-pb-sm items-end full-width">
        <div class="col column">
          <p class="text-body text-weight-medium text-grey-6 q-mb-xs">Spent</p>
          <p class="text-bold text-primary">{{ actual | currency }}</p>
        </div>
        <div class="col-6 column items-center">
          <p class="text-body text-weight-bold q-mb-sm">Available Balance</p>
          <p class="text-h2">{{ variance | currency }}</p>
        </div>
        <div class="col column items-end">
          <p class="text-body text-weight-medium text-grey-6 q-mb-xs">
            Budget
          </p>
          <p class="text-bold text-grey-6">{{ budget | currency }}</p>
        </div>
      </div>
      <SAIProgress
        class="q-mt-xs"
        :progress="(actual / budget) * 100"
        exceeded-color="warning"
      />
    </div>
  </QCard>
</template>

<script>
import { QCard } from 'quasar';
import { SAIProgress, SAICardToggle, SAISpinner } from 'ecx.saigon.ui.common';

export default {
  name: 'BudgetSummaryCard',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    actual: Number,
    budget: Number,
    variance: Number,
    loading: Boolean
  },
  components: {
    QCard,
    SAIProgress,
    SAICardToggle,
    SAISpinner
  }
};
</script>
